import React from 'react';
import { makeStyles, useTheme } from '@material-ui/core';
import { Link } from 'react-router-dom';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import PropTypes from 'prop-types';
import { useAppContext } from 'hooks/useAppContext';
import Color from 'color';

const useStyles = makeStyles(({ palette }) => {
  const accentColor = Color(palette.primary.main)
    .lighten(1)
    .fade(.9)
    .toString();
  return {
    root: {
      color: palette.text.secondary,
      padding: '0.5rem 1rem'
    },
    selected: {
      '&.Mui-selected': {
        fontWeight: 500,
        backgroundColor: accentColor,
        color: palette.primary.main,
        borderLeft: "3px solid",
        borderRadius: 0
      },
    }
  };
});

const capitalize = (s) => {
  if (typeof s !== 'string') return ''
  return s.charAt(0).toUpperCase() + s.slice(1)
}

const collapseIconStyles = {
  left: "6px",
  top: "1px"
}

const SideMenuItem = React.forwardRef(({ moduleName, handleClick, route, icon: Icon, className, children}, ref) => {
  const classes = useStyles();
  const { palette } = useTheme();
  const { selectedProject, currentModule, subModule1 } = useAppContext();

  const currentModuleLower = currentModule ? currentModule.toLowerCase() : "";
  const moduleNameNoSpace = moduleName.replace(" ", "").toLowerCase();
  
  const StyledChildren = () => React.Children.map(children, child => {
    return React.cloneElement(child, { style: currentModuleLower === moduleNameNoSpace ? {color: palette.primary.main, ...collapseIconStyles} : collapseIconStyles, className: classes.collapseIcon } ) || null
  });

  return (
    <ListItem
      key={moduleName}
      to={route ? route : `/projects/${selectedProject}/${moduleName}`}
      component={Link}
      button={true}
      selected={currentModuleLower === moduleNameNoSpace || subModule1 === moduleNameNoSpace}
      onClick={(e) => handleClick(e, moduleName)}
      classes={classes}
      className={className}
    >
      <ListItemIcon style={currentModuleLower === moduleNameNoSpace ? {color: palette.primary.main} : {}}><Icon /></ListItemIcon>
      <ListItemText primary={capitalize(moduleName)} />
      {children && <StyledChildren />}
    </ListItem>
  )
});

SideMenuItem.propTypes = { 
  moduleName: PropTypes.string.isRequired,
  handleClick: PropTypes.func
}

SideMenuItem.defaultProps = {
  handleClick: () => {}
}

export default SideMenuItem;